"use client"

export default function QuestionsError({ reset }: { reset: () => void }) {
  return (
    <section className="mx-auto max-w-3xl px-6 py-20 text-center" role="alert">
      <h1 className="text-2xl font-semibold">The question library is temporarily unavailable.</h1>
      <p className="mt-3 text-zinc-500">Please try again in a moment.</p>
      <button
        onClick={reset}
        className="mt-6 rounded-xl bg-purple-600 px-5 py-3 font-medium text-white hover:bg-purple-700"
      >
        Try again
      </button>
    </section>
  )
}
